if (!customElements.get('allnat-cart-recommend')) {
  const ROTATE_MS = 9000;

  class AllnatCartRecommend extends HTMLElement {
    connectedCallback() {
      if (this.dataset.allnatInit) return;
      this.dataset.allnatInit = 'true';

      const wrap = this;
      let dataEl = document.getElementById('allnat-recommend-data');
      let list = [];

      function loadList() {
        dataEl = document.getElementById('allnat-recommend-data');
        if (!dataEl) {
          list = [];
          return;
        }
        try {
          list = JSON.parse(dataEl.textContent);
        } catch (e) {
          list = [];
        }
      }

      loadList();

      const card = wrap.querySelector('[data-allnat-card]');
      const linkEl = wrap.querySelector('[data-allnat-link]');
      const imgEl = wrap.querySelector('[data-allnat-img]');
      const nameEl = wrap.querySelector('[data-allnat-name]');
      const priceEl = wrap.querySelector('[data-allnat-price]');
      const dotsEl = wrap.querySelector('[data-allnat-dots]');
      const addBtn = wrap.querySelector('[data-allnat-add]');

      let current = 0;
      let timer = null;

      function priceHtml(p) {
        if (p.compareAtPrice) {
          return `<span class="was">${p.compareAtPrice}</span>${p.price}`;
        }
        return p.price;
      }

      function renderDots() {
        dotsEl.innerHTML = list
          .map((_, i) => `<span class="${i === current ? 'active' : ''}" data-index="${i}"></span>`)
          .join('');
      }

      function applyProduct(p) {
        imgEl.src = p.image;
        imgEl.alt = p.name;
        nameEl.textContent = p.name;
        priceEl.innerHTML = priceHtml(p);
        linkEl.href = p.url;
        wrap.style.setProperty('--brand-color', p.brandColor);
        wrap.style.setProperty('--brand-light', p.brandLight);
        addBtn.dataset.variantId = p.variantId;
        wrap.dataset.allnatInit = 'true';
        renderDots();
      }

      function goTo(index) {
        current = index;
        card.classList.add('is-fading');
        setTimeout(() => {
          applyProduct(list[current]);
          card.classList.remove('is-fading');
        }, 280);
      }

      function next() {
        goTo((current + 1) % list.length);
      }

      function restartTimer() {
        clearInterval(timer);
        if (list.length > 1) {
          timer = setInterval(next, ROTATE_MS);
        }
      }

      function resync() {
        loadList();
        clearInterval(timer);
        if (!list.length) {
          wrap.hidden = true;
          return;
        }
        wrap.hidden = false;
        current = 0;
        card.classList.remove('is-fading');
        applyProduct(list[current]);
        restartTimer();
      }

      const dataObserver = new MutationObserver(resync);
      if (dataEl) {
        dataObserver.observe(dataEl, { childList: true, characterData: true, subtree: true });
      }

      function selfHeal() {
        if (!list.length) return;
        const expected = list[current].name;
        if (nameEl.textContent === expected && wrap.dataset.allnatInit === 'true') return;
        applyProduct(list[current]);
      }

      const selfHealObserver = new MutationObserver(selfHeal);
      selfHealObserver.observe(wrap, { attributes: true, childList: true, subtree: true, characterData: true });

      dotsEl.addEventListener('click', (e) => {
        const dot = e.target.closest('span[data-index]');
        if (!dot) return;
        const index = Number(dot.dataset.index);
        if (index === current) return;
        goTo(index);
        restartTimer();
      });

      addBtn.addEventListener('click', async () => {
        const variantId = addBtn.dataset.variantId;
        if (!variantId) return;
        addBtn.disabled = true;
        try {
          const formData = new FormData();
          formData.append('id', variantId);
          formData.append('quantity', 1);
          formData.append('sections', 'cart-drawer-section');

          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: formData,
          });
          const data = await res.json();

          const freshHtml = data.sections && data.sections['cart-drawer-section'];
          if (freshHtml) {
            const freshDoc = new DOMParser().parseFromString(freshHtml, 'text/html');
            const freshItems = freshDoc.querySelector('cart-items-component');
            const liveItems = document.querySelector('cart-items-component');
            if (freshItems && liveItems) {
              liveItems.innerHTML = freshItems.innerHTML;
            }
          }
        } catch (e) {
          addBtn.disabled = false;
        }
      });

      if (list.length) {
        applyProduct(list[current]);
        restartTimer();
      }

      wrap.__allnatCleanup = () => {
        clearInterval(timer);
        dataObserver.disconnect();
        selfHealObserver.disconnect();
      };
    }

    disconnectedCallback() {
      if (this.__allnatCleanup) this.__allnatCleanup();
    }
  }

  customElements.define('allnat-cart-recommend', AllnatCartRecommend);
}